import useRequiresAdmin from "utils/useRequiresAdmin";

const useController = () => {
	useRequiresAdmin();

	return {};
};

export default useController;
